
import { defineComponent } from "@vue/runtime-core";
import Spinner from "./Spinner.vue";

export default defineComponent({
  name: "PendingItem",
  components: { Spinner },
  props: {
    status: Number,
    error: String,
    info: String,
  },
  computed: {
    isPending: function () {
      return this.status == 1;
    },
    isCompleted: function () {
      return this.status == 2;
    },
    errorous() {
      return this.error != "";
    },
  },
});
